import React from 'react';
import { useController } from 'react-hook-form';
import { Flex, Col, Body3Light } from '@/ui';
import { COLORS } from '@/utils/static';
import { Radio } from '@/components/common/atoms';
import { Radio as ANTDRadio, Tooltip } from 'antd';

const defaultRowProps = { vertical: true };

export const RadioGroupForm = ({
  form,
  items,
  ids,
  rowProps = defaultRowProps,
  disabled,
  pointsScoring,
  points,
  isSelectScoringTooltip,
  ...props
}) => {
  const {
    field: { ref, ...field },
    fieldState: { error }
  } = useController({
    ...form,
    defaultValue: ''
  });
  const { onChange, value, ...otherField } = field;

  const handleChange = (newValue) => {
    onChange(newValue === value ? '' : newValue);
  };

  return (
    <div>
      <Flex {...rowProps} $marginLeft={12}>
        <ANTDRadio.Group
          {...props}
          {...otherField}
          value={value}
          onChange={handleChange}
          disabled={disabled}
        >
          {items?.map((label, key) => {
            const radioId = (ids && ids[key]) || label.toLowerCase();
            const pointsScoringValue =
              pointsScoring && pointsScoring.length > 0 ? pointsScoring[key] : 0;
            const pointsValue = points && points.length > 0 ? points[key] : 0;

            if (isSelectScoringTooltip && pointsScoringValue > 0) {
              return (
                <Tooltip title={`+${pointsScoringValue}`} placement='left' key={key}>
                  <Col $auto $marginBottom={5}>
                    <Radio value={radioId} disabled={disabled}>
                      {label}
                    </Radio>
                  </Col>
                </Tooltip>
              );
            } else if (isSelectScoringTooltip && pointsValue > 0) {
              return (
                <Tooltip title={`+${pointsValue}`} placement='left' key={key}>
                  <Col $auto $marginBottom={5}>
                    <Radio value={radioId} disabled={disabled}>
                      {label}
                    </Radio>
                  </Col>
                </Tooltip>
              );
            } else {
              return (
                <Col $auto key={key} $marginBottom={5}>
                  <Radio value={radioId} disabled={disabled}>
                    {label}
                  </Radio>
                </Col>
              );
            }
          })}
        </ANTDRadio.Group>
      </Flex>

      {error && (
        <Body3Light $color={COLORS.red} $marginTop={12}>
          {error.message}
        </Body3Light>
      )}
    </div>
  );
};
